import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_BOARD, GET_BOARD_SUCCESS, GET_BOARD_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getBoard({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/boards`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOARD_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOARD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOARD_ERROR, payload: error });
  }
}

export function* watchGetBoard() {
  yield takeEvery(GET_BOARD, getBoard);
}

function* getBoardSaga() {
  yield all([fork(watchGetBoard)]);
}

export default getBoardSaga;